import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import ListPagination from './components/ListPagination.vue';

// 引入樣式
import './assets/scss/style.scss';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.component('ListPagination', ListPagination);

app.mount('#app');
